import React from "react";
import {TextField} from "@mui/material";
import {forms, validation} from "@atttomyx/shared-utils";

const ContactForm = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = {...data};

        modified[field] = value;
        modified.valid = modified.email
            && validation.validEmail(modified.email)
            && validation.validPhone(modified.phone);

        onSync(modified);
    };

    return <div className="contact-form">
        <div className="field top-margin">
            <TextField
                label="First Name"
                type="text"
                value={forms.sanitizeValue(data.firstName)}
                onChange={(event) => onChange("firstName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Last Name"
                type="text"
                value={forms.sanitizeValue(data.lastName)}
                onChange={(event) => onChange("lastName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Email"
                type="email"
                value={forms.sanitizeValue(data.email)}
                error={!validation.validEmail(data.email)}
                onChange={(event) => onChange("email", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Phone"
                type="tel"
                value={forms.sanitizeValue(data.phone)}
                error={!validation.validPhone(data.phone)}
                onChange={(event) => onChange("phone", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Lead Source"
                type="text"
                value={forms.sanitizeValue(data.leadSource)}
                onChange={(event) => onChange("leadSource", event.target.value)}
            />
        </div>
    </div>
}

export default ContactForm;
